<template>
  <v-card>
    <v-card-title class="indigo darken-1" dark>
      <h2>
        <font style="color: white">查詢進出資料</font>
      </h2>
      <v-spacer></v-spacer>

      <v-btn
        color="grey lighten-3"
        style="color: indigo darken-1"
        small
        @click="handleClose"
      >
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-container>
      <v-col cols="12" md="12">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="employer.visitDate"
              label="日期"
              readonly
              v-on="on"
              dense
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="employer.visitDate"
            locale="zh-cn"
            no-title
            @input="menu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="12">
        <v-text-field
          label="聯繫方式(例：手機、家用或公司電話…)"
          type="text"
          class="font-weight-normal"
          v-model="employer.phone"
          dense
          counter
          maxlength="20"
        ></v-text-field>
      </v-col>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="teal" @click="handleSave" dark>
        <v-avatar left> <v-icon>mdi-check</v-icon> </v-avatar>確認
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    selectItem: {},
  },

  computed: {},
  data() {
    return {
      continueKey: null,
      employer: this.getlesModel("employer"),
    };
  },
  methods: {
    handleSave() {
      var vm = this;

      var visitDateValue = vm.employer.visitDate;
      var phoneValue = vm.employer.phone;
      vm.$router.push({
        path: "/employerDisplay/" + phoneValue + "/" + visitDateValue,
      });
    },

    handleClose() {
      var vm = this;

      vm.$router.push({
        path: "/FormEmployer/init",
      });
    },
  },
  // beforeDestroy() {
  //   this.$emit("update-item", this.newItem);
  //   this.$emit("childDialog");
  // },
};
</script>
